import { SimpleItemProps } from "../../../../../ootr/inventory/items/SimpleItemProps";
import Item, { ItemSharedProps } from "../../../../items/Item";
import StaticItem from "../../../../items/StaticItem";
import CLeft from "../cleft.png";


const ButtonCLeftItem = (props: ItemSharedProps) => {

    return <Item {...props} id="ButtonCLeft" image={CLeft} title="C-Left" />
}

export default ButtonCLeftItem;

export const SimpleButtonCLeftItem= (props: SimpleItemProps) => {

     return <StaticItem
        image={CLeft}
        onClick={props.onClick}
        name={"SimpleMaskOfTruthItem"}
    />


}